import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Initialize tabs when the controller connects
    this.initializeTabs()
  }

  initializeTabs() {
    const tabLinks = this.element.querySelectorAll('.nav-tabs a')

    tabLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        tabLinks.forEach(l => l.parentElement.classList.remove('active'))

        link.parentElement.classList.add('active')

        const tabPanes = this.element.querySelectorAll('.tab-pane')
        tabPanes.forEach(pane => pane.classList.remove('active'))

        // Handle both static and dynamic tabs
        const href = link.getAttribute('href')
        if (href.startsWith('#')) {
          // Static tab (First tab that loads)
          const targetId = href.substring(1)
          const targetPane = this.element.querySelector(`#${targetId}`)
          if (targetPane) {
            targetPane.classList.add('active')
          }
        } else {
          // Dynamic tab (Subsequent tabs)
          const turboFrame = this.element.querySelector('turbo-frame')
          if (turboFrame) {
            turboFrame.classList.add('active')
          }
        }
      })
    })
  }

  switch(event) {
    const link = event.currentTarget

    // Remove active class from all tabs
    const tabLinks = this.element.querySelectorAll('.nav-tabs a')
    tabLinks.forEach(l => l.parentElement.classList.remove('active'))

    // Add active class to clicked tab
    link.parentElement.classList.add('active')

    const tabPanes = this.element.querySelectorAll('.tab-pane')
    tabPanes.forEach(pane => pane.classList.remove('active'))

    // Show the turbo frame
    const turboFrame = this.element.querySelector('turbo-frame')
    if (turboFrame) {
      turboFrame.classList.add('active')
    }
  }
}
